import clsxm from '@/lib/clsxm';

import { SectionHeading, tone } from '@/components/agents/primitives';

export interface UseCaseItem {
  title: string;
  description: string;
}

/**
 * Who the tool is for. English only: the corpus (templateUseCases) has no
 * translations, and only the current template's entries reach the client.
 */
export default function TemplateUseCases({
  useCases,
}: {
  useCases: UseCaseItem[];
}) {
  if (!useCases.length) return null;

  return (
    <section className='mx-auto max-w-6xl px-4 pt-24 sm:px-6 sm:pt-32 lg:px-8'>
      <SectionHeading
        size='md'
        title='Who it’s for.'
        tail='And what they make with it.'
      />
      <ul className='mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3'>
        {useCases.map((useCase) => (
          <li
            key={useCase.title}
            className={clsxm(
              'rounded-[22px] p-6 sm:p-7',
              tone.surface,
              tone.line,
            )}
          >
            <h3
              className={clsxm('text-[17px] font-semibold leading-6', tone.ink)}
            >
              {useCase.title}
            </h3>
            <p className={clsxm('mt-3 text-[15px] leading-7', tone.body)}>
              {useCase.description}
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
}
